// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2pYct","Logo":"Header_Logo__3Bd1m","Hamburger":"Header_Hamburger__1CcxZ","open":"Header_open__2KY_t"};